import React, { useState, useEffect } from 'react';

// Fíjate que aquí agregamos permisosCRUD a las propiedades que recibe el componente
export default function GestorDocumentalTH({ usuario, categoria, permisosCRUD, onBackToMenu }) {
  const [documentos, setDocumentos] = useState([]);
  
  // Estados de Modales
  const [modalSubir, setModalSubir] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalEliminar, setModalEliminar] = useState(false);
  const [docSeleccionado, setDocSeleccionado] = useState(null);
  
  const [cargando, setCargando] = useState(false);
  const [archivo, setArchivo] = useState(null);
  
  // Notificación flotante (Toast)
  const [toast, setToast] = useState({ visible: false, mensaje: '', tipo: '' });
  
  const [formData, setFormData] = useState({ titulo: '', descripcion: '' });

  const API_URL = process.env.REACT_APP_API_URL ;

  // LECTURA DINÁMICA DE PERMISOS ABAC (Ahora vienen directamente del padre ya procesados y limpios)
  const esSuperAdmin = String(usuario?.cargo || "").toUpperCase().includes("SUPER");
  
  // Usamos los permisos que nos pasó GestionHumana.js (o por defecto false si no los mandó)
  const puedeCrear = esSuperAdmin || (permisosCRUD && permisosCRUD.crear);
  const puedeEditar = esSuperAdmin || (permisosCRUD && permisosCRUD.editar);
  const puedeEliminar = esSuperAdmin || (permisosCRUD && permisosCRUD.eliminar);

  useEffect(() => {
    cargarDocumentos();
    // eslint-disable-next-line
  }, [categoria]);

  // Función para mostrar alertas bonitas
  const mostrarToast = (mensaje, tipo = 'exito') => {
    setToast({ visible: true, mensaje, tipo });
    setTimeout(() => setToast({ visible: false, mensaje: '', tipo: '' }), 4000);
  };

  const cargarDocumentos = async () => {
    try {
      const response = await fetch(`${API_URL}/api/documentos-th/listar?categoria=${categoria}`);
      if (response.ok) {
        const result = await response.json();
        setDocumentos(result.data || []);
      } else {
        setDocumentos([]);
      }
    } catch (error) {
      console.error("Error al cargar:", error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  // SUBIR
  const handleSubirSubmit = async (e) => {
    e.preventDefault();
    if (!archivo) return mostrarToast("Debes adjuntar un archivo.", "error");
    setCargando(true);

    try {
      // 1. Función auxiliar para convertir el archivo físico a texto Base64
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      // Transformamos el archivo seleccionado
      const base64String = await toBase64(archivo);

      // 2. Armamos un paquete JSON exactamente como lo pide el backend
      const payload = {
        categoria: categoria,
        titulo: formData.titulo,
        descripcion: formData.descripcion,
        creado_por: usuario?.nombres || 'Admin',
        archivo_base64: base64String, 
        tipo_mime: archivo.type       
      };

      // 3. Enviamos la petición asegurándonos de usar las cabeceras JSON
      const response = await fetch(`${API_URL}/api/documentos-th/crear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json' 
        },
        body: JSON.stringify(payload)
      });
      
      const result = await response.json();

      if (response.ok && result.success) {
        mostrarToast('Documento subido con éxito');
        setModalSubir(false);
        setFormData({ titulo: '', descripcion: '' });
        setArchivo(null);
        cargarDocumentos(); 
      } else {
        mostrarToast(`Error al subir: ${result.message}`, 'error');
      }
    } catch (error) {
      console.error(error);
      mostrarToast('Error de conexión', 'error');
    } finally {
      setCargando(false);
    }
  };

  // EDITAR
  const abrirModalEditar = (doc) => {
    setDocSeleccionado(doc);
    setFormData({ titulo: doc.titulo, descripcion: doc.descripcion });
    setModalEditar(true);
  };

  const handleEditarSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      const response = await fetch(`${API_URL}/api/documentos-th/editar/${docSeleccionado.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ titulo: formData.titulo, descripcion: formData.descripcion }),
      });
      const result = await response.json();

      if (response.ok && result.success) {
        mostrarToast('Documento actualizado correctamente');
        setModalEditar(false);
        cargarDocumentos();
      } else {
        mostrarToast('Error al actualizar', 'error');
      }
    } catch (error) {
      mostrarToast('Error de red al actualizar', 'error');
    } finally {
      setCargando(false);
    }
  };

  // ELIMINAR
  const confirmarEliminacion = (doc) => {
    setDocSeleccionado(doc);
    setModalEliminar(true);
  };

  const ejecutarEliminacion = async () => {
    setCargando(true);
    try {
      const response = await fetch(`${API_URL}/api/documentos-th/eliminar/${docSeleccionado.id}`, {
        method: 'DELETE',
      });
      const result = await response.json();
      if (response.ok && result.success) {
        mostrarToast('Documento eliminado de la base de datos');
        setModalEliminar(false);
        cargarDocumentos();
      } else {
        mostrarToast('Error al eliminar', 'error');
      }
    } catch (error) {
      mostrarToast('Error de red al eliminar', 'error');
    } finally {
      setCargando(false);
    }
  };

  const getIconoMenu = (cat) => {
    const iconos = { 
      "Organigrama": "🏢", 
      "Reglamento Interno": "📖", 
      "Políticas T.H.": "🛡️", 
      "Formatos y Trámites": "📝", 
      "Onboarding": "🚀",
      "Manuales de Cargo": "📘",
      "Perfiles de Cargos": "📝",
      "Rutas": "🚌",
      "Personal con Discapacidad": "♿",
      "Maternas": "🤰" 
    };
    return iconos[cat] || "📁";
  };

  const getIconoArchivo = (mime) => {
    if (!mime) return "📄";
    if (mime.includes("image")) return "🖼️";
    if (mime.includes("pdf")) return "📕";
    if (mime.includes("word") || mime.includes("document")) return "📘";
    if (mime.includes("excel") || mime.includes("sheet")) return "📗";
    return "📄";
  };

  return (
    <div className="w-full min-h-screen p-4 sm:p-8 animate-fade-in relative z-10">
      
      {/* TOAST NOTIFICATION */}
      {toast.visible && (
        <div className={`fixed top-10 left-1/2 transform -translate-x-1/2 z-[99999] px-6 py-3 rounded-full shadow-2xl font-bold text-sm flex items-center gap-3 animate-fade-in-down transition-all ${toast.tipo === 'exito' ? 'bg-green-500 text-white shadow-green-500/40' : 'bg-red-500 text-white shadow-red-500/40'}`}>
          <span>{toast.tipo === 'exito' ? '✅' : '❌'}</span>
          {toast.mensaje}
        </div>
      )}

      <div className="bg-white/40 backdrop-blur-[40px] rounded-[34px] shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-6 sm:p-10 max-w-7xl mx-auto border border-white/60">
        
        {/* CABECERA */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-gray-400/20 pb-6 mb-8 gap-4">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-white/80 text-gray-700 flex items-center justify-center text-3xl shadow-sm border border-white shrink-0">
              {getIconoMenu(categoria)}
            </div>
            <div>
              <h2 className="text-2xl font-black text-gray-800 tracking-tight">{categoria}</h2>
              <p className="text-xs font-bold text-gray-500 mt-1 uppercase tracking-wider">Biblioteca Documental TH</p>
            </div>
          </div>
          <div className="flex gap-3">
            {puedeCrear && (
              <button 
                onClick={() => {
                  setFormData({ titulo: '', descripcion: '' });
                  setModalSubir(true);
                }}
                className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-xs font-black tracking-widest transition-all shadow-[0_8px_20px_rgba(37,99,235,0.3)] hover:-translate-y-0.5 cursor-pointer"
              >
                + SUBIR DOCUMENTO
              </button>
            )}
            <button 
              onClick={onBackToMenu}
              className="px-6 py-3 rounded-xl bg-white/70 hover:bg-white text-gray-800 text-xs font-bold transition-all border border-gray-200 shadow-sm hover:-translate-y-0.5 cursor-pointer"
            >
              Volver al Menú
            </button>
          </div>
        </div>

        {/* GALERÍA DE TARJETAS */}
        {documentos.length === 0 ? (
          <div className="text-center py-20 bg-white/30 rounded-3xl border border-white border-dashed">
            <span className="text-5xl opacity-50 block mb-4">📭</span>
            <p className="text-gray-500 font-bold">No hay documentos en la carpeta de {categoria}.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {documentos.map((doc) => (
              <div key={doc.id} className="bg-white/70 backdrop-blur-md rounded-[28px] p-5 border border-white shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all group flex flex-col h-full relative overflow-hidden">
                
                <div className="absolute -right-6 -top-6 w-24 h-24 bg-blue-500/10 rounded-full blur-2xl group-hover:bg-blue-500/20 transition-all"></div>

                <div className="h-32 bg-slate-100/50 rounded-2xl mb-4 flex flex-col items-center justify-center border border-slate-200/50 relative overflow-hidden">
                   <span className="text-6xl drop-shadow-sm group-hover:scale-110 transition-transform duration-300">
                     {getIconoArchivo(doc.tipo_mime)}
                   </span>
                </div>
                
                <h3 className="text-sm font-black text-gray-800 leading-tight mb-2 line-clamp-2">{doc.titulo}</h3>
                <p className="text-[11px] text-gray-500 line-clamp-3 mb-4 flex-grow">{doc.descripcion}</p>
                
                <div className="flex justify-between items-center mt-auto pt-4 border-t border-gray-100">
                  <span className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">
                    {new Date(doc.fecha_creacion).toLocaleDateString()}
                  </span>
                  
                  {/* BOTONERA CONTROLADA POR ABAC (EDITAR / ELIMINAR) */}
                  <div className="flex gap-2 z-10">
                    {puedeEditar && (
                      <button onClick={() => abrirModalEditar(doc)} title="Editar" className="w-8 h-8 rounded-full bg-orange-50 text-orange-600 flex items-center justify-center hover:bg-orange-500 hover:text-white transition-colors border border-orange-200 cursor-pointer text-sm shadow-sm">
                        ✏️
                      </button>
                    )}
                    {puedeEliminar && (
                      <button onClick={() => confirmarEliminacion(doc)} title="Eliminar" className="w-8 h-8 rounded-full bg-red-50 text-red-600 flex items-center justify-center hover:bg-red-500 hover:text-white transition-colors border border-red-200 cursor-pointer text-sm shadow-sm">
                        🗑️
                      </button>
                    )}
                    <a href={`${API_URL}/api/documentos-th/archivo/${doc.id}`} target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors border border-blue-200 cursor-pointer text-sm shadow-sm" title="Ver/Descargar">
                      ⬇️
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* MODAL PARA SUBIR */}
      {modalSubir && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-white rounded-[32px] shadow-2xl p-8 w-full max-w-lg border border-gray-100 animate-fade-in">
            <div className="flex justify-between items-center mb-6 border-b border-gray-100 pb-4">
              <h3 className="text-xl font-black text-gray-800">Subir a {categoria}</h3>
              <button onClick={() => setModalSubir(false)} className="w-8 h-8 bg-gray-100 rounded-full text-gray-600 font-bold hover:bg-red-100 hover:text-red-600 transition cursor-pointer">✕</button>
            </div>
            <form onSubmit={handleSubirSubmit} className="flex flex-col gap-5">
              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Título del Documento</label>
                <input type="text" name="titulo" required value={formData.titulo} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none transition" />
              </div>
              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Descripción</label>
                <textarea name="descripcion" required value={formData.descripcion} onChange={handleInputChange} rows="3" className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-blue-500 outline-none resize-none transition"></textarea>
              </div>
              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Archivo (PDF, Imagen)</label>
                <input type="file" required accept=".pdf,image/*" onChange={handleFileChange} className="w-full file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-bold file:bg-blue-100 file:text-blue-700 hover:file:bg-blue-200 text-sm text-gray-600 cursor-pointer transition" />
              </div>
              <button type="submit" disabled={cargando} className="w-full mt-2 py-4 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-black tracking-widest uppercase text-sm disabled:opacity-50 cursor-pointer shadow-lg transition">
                {cargando ? 'Guardando...' : 'Subir Documento'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* MODAL PARA EDITAR */}
      {modalEditar && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-white rounded-[32px] shadow-2xl p-8 w-full max-w-lg border border-gray-100 animate-fade-in">
            <div className="flex justify-between items-center mb-6 border-b border-gray-100 pb-4">
              <h3 className="text-xl font-black text-gray-800">Editar Detalles</h3>
              <button onClick={() => setModalEditar(false)} className="w-8 h-8 bg-gray-100 rounded-full text-gray-600 font-bold hover:bg-red-100 hover:text-red-600 transition cursor-pointer">✕</button>
            </div>
            <form onSubmit={handleEditarSubmit} className="flex flex-col gap-5">
              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Título del Documento</label>
                <input type="text" name="titulo" required value={formData.titulo} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-orange-500 outline-none transition" />
              </div>
              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Descripción</label>
                <textarea name="descripcion" required value={formData.descripcion} onChange={handleInputChange} rows="3" className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-orange-500 outline-none resize-none transition"></textarea>
              </div>
              <button type="submit" disabled={cargando} className="w-full mt-2 py-4 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-black tracking-widest uppercase text-sm disabled:opacity-50 shadow-lg shadow-orange-500/30 cursor-pointer transition">
                {cargando ? 'Actualizando...' : 'Guardar Cambios'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* MODAL PARA ELIMINAR */}
      {modalEliminar && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-white rounded-[32px] shadow-2xl p-8 w-full max-w-md border border-gray-100 animate-fade-in text-center">
            <div className="w-20 h-20 bg-red-100 rounded-full text-red-500 flex items-center justify-center text-4xl mx-auto mb-4">
              🗑️
            </div>
            <h3 className="text-xl font-black text-gray-800 mb-2">¿Eliminar Documento?</h3>
            <p className="text-sm text-gray-500 mb-8">Estás a punto de eliminar permanentemente "<b>{docSeleccionado?.titulo}</b>". Esta acción no se puede deshacer y el archivo se borrará de la base de datos.</p>
            
            <div className="flex gap-3">
              <button onClick={() => setModalEliminar(false)} className="flex-1 py-4 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold tracking-widest uppercase text-xs transition cursor-pointer">
                Cancelar
              </button>
              <button onClick={ejecutarEliminacion} disabled={cargando} className="flex-1 py-4 rounded-xl bg-red-600 hover:bg-red-700 text-white font-black tracking-widest uppercase text-xs transition disabled:opacity-50 shadow-lg shadow-red-600/30 cursor-pointer">
                {cargando ? 'Borrando...' : 'Sí, Eliminar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}